import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BlogGuide from "../pages/blog/pandabuy-spreadsheet-guide/page";
import BestShoes from "../pages/blog/best-pandabuy-spreadsheet-shoes-2026/page";
import LuxuryFinds from "../pages/blog/luxury-pandabuy-spreadsheet-finds/page";
import BudgetUnder50 from "../pages/blog/budget-pandabuy-spreadsheet-under-50/page";
import NikeCollection from "../pages/blog/nike-shoes-pandabuy-spreadsheet-collection/page";
import HoodiesStreetwear from "../pages/blog/hoodies-streetwear-pandabuy-spreadsheet/page";
import ViralTikTok from "../pages/blog/viral-tiktok-pandabuy-spreadsheet-finds/page";
import BeginnerGuide from "../pages/blog/pandabuy-spreadsheet-beginner-guide/page";
import HaulTips from "../pages/blog/haul-tips-pandabuy-spreadsheet/page";
import ShoppingGuide from "../pages/blog/pandabuy-shopping-guide-2026/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog/pandabuy-spreadsheet-ultimate-guide-2026",
    element: <BlogGuide />,
  },
  {
    path: "/blog/best-pandabuy-spreadsheet-shoes-2026",
    element: <BestShoes />,
  },
  {
    path: "/blog/luxury-pandabuy-spreadsheet-finds",
    element: <LuxuryFinds />,
  },
  {
    path: "/blog/budget-pandabuy-spreadsheet-under-50",
    element: <BudgetUnder50 />,
  },
  {
    path: "/blog/nike-shoes-pandabuy-spreadsheet-collection",
    element: <NikeCollection />,
  },
  {
    path: "/blog/hoodies-streetwear-pandabuy-spreadsheet",
    element: <HoodiesStreetwear />,
  },
  {
    path: "/blog/viral-tiktok-pandabuy-spreadsheet-finds",
    element: <ViralTikTok />,
  },
  {
    path: "/blog/pandabuy-spreadsheet-beginner-guide",
    element: <BeginnerGuide />,
  },
  {
    path: "/blog/haul-tips-pandabuy-spreadsheet",
    element: <HaulTips />,
  },
  {
    path: "/blog/pandabuy-shopping-guide-2026",
    element: <ShoppingGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;